import Graphic from "@arcgis/core/Graphic";

export class GISSearchResult {
  target: Graphic;
  label?: string;

  constructor(target: Graphic, label?: string) {
    this.target = target;
    this.label = label;
  }
}
